/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-06-20 15:02:41
 * @Description: 
 */
/**
  * 配置 接口的出口
  */
import axios from '../.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const mangheset = {
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'mangheset/detail', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'mangheset/edit', qs.stringify(params))
    },
    //修改邮费
    editfarerule (params) {
        return axios.post(api + 'mangheset/editfarerule', qs.stringify(params))
    },
}


// 导出接口
export default mangheset